import { List, Create, BulkCreate, Edit, Show, UserLeaves } from "../Components/index.js";

export default [
    {
        path: "/admin/plan-leave",
        component: List,
        name: "admin.plan.leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/plan-leave/bulk-create",
        component: BulkCreate,
        name: "admin.plan.leave.bulk.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/plan-leave/create",
        component: Create,
        name: "admin.plan.leave.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/plan-leave/:id/edit",
        component: Edit,
        name: "admin.plan.leave.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave-type-users/:id/show",
        component: Show,
        name: "leave.type.users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/user/plan-leave/:id/show",
        component: UserLeaves,
        name: "user.leave.type.users",
        meta: {
            requiresAuth: true,
        },
    },
];
